import { createAction } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";


export const initialStateObj = {
  value: {},
  status: COMMON_STATUS.INITIAL
};


export const initialStateNull = {
  value: null,
  status: COMMON_STATUS.INITIAL
};


export const getCartAction = createAction("cart/getCart")
export const logoutUser = createAction("auth/logout")